import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ApplicationService } from "../../services/application.service";

@Component({
  selector: "app-screen-error",
  templateUrl: "./error.html",
  styleUrls: ["./error.less"],
})
export class ErrorComponent {
  public constructor(public readonly applicationService: ApplicationService, public readonly translateService: TranslateService) {
    this.applicationService.updateTitle("Oops!");
  }
}
